
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.669 9.373a.376.376 0 00.651 0l2.477-4.087c.153-.264 0-.479-.343-.479H8.827V1.824a.834.834 0 00-1.667 0v2.985H5.527c-.34 0-.5.215-.343.479z","fill":"#990ae3"}}),_c('path',{attrs:{"d":"M13.157 7.921h-1.469a.829.829 0 00-.834.824.829.829 0 00.834.824h.635a1 1 0 011 .987v1.813a1 1 0 01-1 .987h-8.66a1 1 0 01-1-.987v-1.813a1 1 0 011-.987H4.3a.829.829 0 00.831-.824.828.828 0 00-.831-.824H2.832A1.824 1.824 0 001 9.732v3.459A1.822 1.822 0 002.832 15h10.325a1.824 1.824 0 001.832-1.811V9.732a1.824 1.824 0 00-1.832-1.811z","fill":"#990ae3"}})])
          )
        }
      }
    